import React from 'react';
import { PaginatedTable } from './PaginatedTable';
import { ActionType, ColumnDefinition, RowType } from './GenericTable';

interface SearchResultsContainerProps<T> {
  items: T[] | null | undefined;
  queryInProgress: boolean;
  itemsPerPage: number;
  columnDefs: Record<string, ColumnDefinition>;
  listOfActions: Array<
    [React.ReactNode, (id: string, row: T) => void | Promise<void>]
  >;
}

export const SearchResultsContainer = <T,>({
  items,
  queryInProgress,
  itemsPerPage,
  columnDefs,
  listOfActions,
}: SearchResultsContainerProps<T>): JSX.Element => {
  return (
    <div className="flex-auto w-full max-w-7xl">
      {items && items.length > 0 ? (
        <PaginatedTable
          itemsPerPage={itemsPerPage}
          items={items as RowType[]}
          columnDefs={columnDefs}
          listOfActions={listOfActions as ActionType<RowType>[]}
        />
      ) : (
        !queryInProgress && <h1 className="flex py-10 px-80">No items found</h1>
      )}
    </div>
  );
};
